/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React base styles
import typography from "assets/theme/base/typography";
import colors from "assets/theme/base/colors";

// Vision UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import { TC } from "../../../../tokens/text";

const { size, fontWeightRegular } = typography;
const { grey, dark, text } = colors;

export default {
  styleOverrides: {
    label: {
      marginTop: `${pxToRem(8)} !important`,
      fontWeight: fontWeightRegular,
      fontSize: size.sm,
      color: TC.tertiary,

      "&.Mui-active": {
        fontWeight: `700 !important`,
        color: `#0a1628 !important`,
      },

      "&.Mui-completed": {
        fontWeight: `600 !important`,
        color: `#0057d8 !important`,
      },
    },
  },
};

